import React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  StyleSheet,
  Platform,
} from "react-native";

import ImageComponent from "../../common/ImageComponent";
import { isWeb, isSleep } from "../../../../helpers/utils";

function Prediction({
  prediction,
  onActivitySelected = () => {},
  onLongPress = () => {},
  editMode = false,
  position,
  showIcons,
  tutorialStep,
}) {
  if (!prediction.name) return;

  const isSelectable =
    tutorialStep == 1 ? isSleep(prediction.name) : !tutorialStep;

  const words = prediction.name
    .split(" ")
    .slice(0, 2)
    .map((w, i) => (
      <Text
        key={i}
        title={prediction.name}
        numberOfLines={1}
        style={[
          styles.word,
          styles.wordOverflow,
          editMode && { color: "#2D3142" },
          !editMode &&
            isWeb && {
              color: "#2D3142",
            },
        ]}
      >
        {w}
      </Text>
    ));

  const predictionName = words;

  const onPredictionSelected = () => {
    if (isSelectable) {
      onActivitySelected(prediction, true, true, false, "p" + (position + 1));
    }
  };

  return (
    <>
      {editMode ? (
        /* Disabled for edit page */
        <View style={[styles.flex, styles.chip, styles.chipDisabled]}>
          {showIcons && prediction.icon ? (
            <ImageComponent
              icon={prediction.icon}
              action={onPredictionSelected}
              styles={styles.predictionIcon}
            />
          ) : null}
          <View style={[styles.chipTextContainer]}>{predictionName}</View>
        </View>
      ) : (
        /* Enabled */
        <View
          style={[
            styles.flex,
            styles.chip,
            {
              width: 112,
              backgroundColor: "#F4F6FA",
            },
          ]}
        >
          <TouchableOpacity
            style={[styles.flex]}
            onPress={onPredictionSelected}
            onLongPress={onLongPress}
          >
            {showIcons && !!prediction.icon ? (
              <ImageComponent
                icon={prediction.icon}
                action={onPredictionSelected}
                styles={[styles.predictionIcon]}
              />
            ) : null}

            <View style={[styles.chipTextContainer]}>{predictionName}</View>
          </TouchableOpacity>
        </View>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  flex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
  },
  predictionIcon: {
    width: 20,
    height: 20,
    marginRight: 5,
  },
  chip: {
    height: 34,
    width: "auto",
    maxWidth: "100%",
    borderColor: "#F1FFFA",
    borderWidth: 1,
    marginRight: 4,
    paddingVertical: 2,
    paddingHorizontal: 10,
    borderRadius: 30,
    minWidth: 112,
    backgroundColor: "#F4F6FA",
  },
  chipDisabled: {
    maxWidth: 190,
    backgroundColor: "#bfc0c3",
  },
  chipTextContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    flex: 1,
  },
  word: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 12,
    lineHeight: 14,
    color: "#2D3142",
    width: "100%",
    textAlign: "center",
  },
  wordOverflow: Platform.select({
    ios: {
      overflow: "hidden",
      display: "flex",
    },
    web: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "pre",
    },
  }),
  predictions: {
    position: "relative",
  },
});

export default Prediction;
